// Product Card Video Initialization
// Global function to initialize product card videos for dynamically loaded content

(function () {
  // Only show videos on desktop devices
  function isDesktop() {
    return window.innerWidth >= 768; // md breakpoint
  }

  function isSafariBrowser() {
    var ua = navigator.userAgent || "";
    var vendor = navigator.vendor || "";
    // Treat Safari (including Mobile Safari) as Safari; exclude Chrome/Chromium/Edge on macOS/iOS
    var isAppleVendor = vendor.indexOf("Apple") > -1;
    var isSafariUA =
      /safari/i.test(ua) && !/chrome|crios|chromium|edg/i.test(ua);
    return isAppleVendor || isSafariUA;
  }

  function updateVideoVisibility(container) {
    // If container is provided, only search within it; otherwise search entire document
    const scope = container || document;
    const videos = scope.querySelectorAll(".product-card-video");
    const fallbackImages = scope.querySelectorAll(".product-fallback-image");

    videos.forEach(function (video) {
      const fallbackImage = video.parentElement.querySelector(
        ".product-fallback-image"
      );

      if (isDesktop()) {
        // Add source tag only on desktop if not already added
        if (!video.querySelector("source")) {
          var safari = isSafariBrowser();
          var webmSrc = video.dataset.videoSrcWebm;
          var movSrc = video.dataset.videoSrcMov;

          var chosenSrc = null;
          var chosenType = null;

          if (safari && movSrc) {
            chosenSrc = movSrc;
            chosenType = "video/quicktime; codecs=hvc1";
          } else if (webmSrc) {
            chosenSrc = webmSrc;
            chosenType = "video/webm; codecs=vp9, opus";
          } else if (movSrc) {
            // Fallback to MOV if WEBM missing
            chosenSrc = movSrc;
            chosenType = "video/quicktime; codecs=hvc1";
          }

          if (chosenSrc) {
            const source = document.createElement("source");
            source.src = chosenSrc;
            if (chosenType) source.type = chosenType;
            video.appendChild(source);
            video.load(); // Load the video with the new source
          }
        }
        // Show video on desktop
        video.style.display = "block";
        if (fallbackImage) {
          fallbackImage.style.display = "none";
        }
      } else {
        // Hide video on mobile (don't add source)
        video.style.display = "none";
        if (fallbackImage) {
          fallbackImage.style.display = "block";
        }
      }
    });
  }

  function setupVideoHoverBehavior(container) {
    // If container is provided, only search within it; otherwise search entire document
    const scope = container || document;
    const productCardVideos = scope.querySelectorAll(".product-card-video");

    productCardVideos.forEach(function (video) {
      // Skip if already initialized
      if (video.dataset.videoInitialized === "true") {
        return;
      }

      const productCard = video.closest(".group");

      if (productCard) {
        // Mark as initialized
        video.dataset.videoInitialized = "true";

        // Ensure video is paused initially
        video.pause();

        // Play on hover anywhere on the card
        productCard.addEventListener("mouseenter", function () {
          if (isDesktop()) {
            video.play();
          }
        });

        // Pause when mouse leaves the card and go back to first frame
        productCard.addEventListener("mouseleave", function () {
          video.pause();
          video.currentTime = 0;
        });
      }
    });
  }

  // Global function to initialize product card videos
  window.initProductCardVideos = function (container) {
    updateVideoVisibility(container);
    setupVideoHoverBehavior(container);
  };

  // Initial setup on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      window.initProductCardVideos();

      // Handle window resize
      let resizeTimeout;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          window.initProductCardVideos();
        }, 250);
      });
    });
  } else {
    window.initProductCardVideos();

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        window.initProductCardVideos();
      }, 250);
    });
  }
})();
